"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileTab = exports.DesktopTabGroup = exports.DesktopTab = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var _jsxRuntime = require("react/jsx-runtime");

var MobileTabWrapper = _styledComponents["default"].div.withConfig({
  displayName: "MobileTabWrapper",
  componentId: "sc-1i1sci6-0"
})(["cursor:pointer;display:flex;justify-content:space-between;border-top:1px solid ", ";border-bottom:", ";padding:16px 0;@media (", "){display:none;}"], _baseReactComponents.theme.scuttleGray100, function (_ref) {
  var activeTab = _ref.activeTab;
  return activeTab ? "4px solid ".concat(_baseReactComponents.theme.mermaidGreen500) : "1px solid ".concat(_baseReactComponents.theme.scuttleGray100);
}, _baseReactComponents.theme.forLargerThanPhone);

var IconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "IconWrapper",
  componentId: "sc-1i1sci6-1"
})(["width:24px;height:24px;", ""], function (_ref2) {
  var activeTab = _ref2.activeTab;
  return activeTab ? 'transform: rotate(180deg)' : '';
});

var DesktopTabGroupWrapper = _styledComponents["default"].ul.withConfig({
  displayName: "DesktopTabGroupWrapper",
  componentId: "sc-1i1sci6-2"
})(["&&{padding:0;margin:0;display:none;background-color:", ";@media (", "){display:flex;}}"], _baseReactComponents.theme.scuttleGray100, _baseReactComponents.theme.forLargerThanPhone);

var DesktopTabWrapper = _styledComponents["default"].li.withConfig({
  displayName: "DesktopTabWrapper",
  componentId: "sc-1i1sci6-3"
})(["&&{cursor:pointer;display:inline-flex;flex-direction:column;padding:0;", "{margin:16px 16px 12px;}}", ""], _baseReactComponents.Copy, function (_ref3) {
  var activeTab = _ref3.activeTab;
  return activeTab && "\n  &:after {\n    content: '';\n    border: 2px solid ".concat(_baseReactComponents.theme.mermaidGreen400, ";\n    border-radius: 2px;\n    margin: 0 12px;\n    background-color: ").concat(_baseReactComponents.theme.mermaidGreen400, ";\n}");
});

var MobileTab = function MobileTab(_ref4) {
  var shownTab = _ref4.shownTab,
      handleShownTab = _ref4.handleShownTab,
      title = _ref4.title;
  var activeTab = shownTab === title;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(MobileTabWrapper, {
    activeTab: activeTab,
    onClick: function onClick() {
      return handleShownTab(title === shownTab ? null : title);
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
      bold: true,
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(IconWrapper, {
      activeTab: activeTab,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
        name: "actions/carrot-down",
        color: _baseReactComponents.theme.scuttleGray400
      })
    })]
  });
};

exports.MobileTab = MobileTab;

var DesktopTabGroup = function DesktopTabGroup(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DesktopTabGroupWrapper, {
    children: children
  });
};

exports.DesktopTabGroup = DesktopTabGroup;

var DesktopTab = function DesktopTab(_ref6) {
  var shownTab = _ref6.shownTab,
      handleShownTab = _ref6.handleShownTab,
      title = _ref6.title;
  var activeTab = shownTab === title;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DesktopTabWrapper, {
    activeTab: activeTab,
    onClick: function onClick() {
      return handleShownTab(title);
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
      light: true,
      bold: true,
      children: title
    })
  });
};

exports.DesktopTab = DesktopTab;
//# sourceMappingURL=details-tabs.js.map